// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KH5IV","top":"styles_top__1T1AE","left":"styles_left__xstMK","description":"styles_description__3qpyB"};